<script>
import {mapActions, mapGetters, mapState} from "vuex";
import ExpandableTable from "@/components/ui/metrics/ExpandableTable.vue";
import Breadcrumbs from "@/components/ui/Breadcrumbs.vue";

export default {
  name: "AnalyticsView",
  components: {ExpandableTable, Breadcrumbs},
  data: () =>({
    dates: [],
    menu: false,
    selectedCommunes: [],
    selectedRoles: []
  }),
  computed: {
    ...mapGetters('user', ['enableAnalytics']),
    ...mapState('metrics', ['metrics', 'filterValues']),
    startDate() {
      if(this.dates.length < 2) {
        return null;
      }


      const date = new Date(this.dates[0]);

      date.setHours(0, 0, 0, 0);
      return date;
    },
    endDate() {
      if(this.dates.length < 2) {
        return null;
      }

      const date = new Date(this.dates[1]);

      date.setHours(23, 59, 59, 999);
      return date;
    },
    dateRangeText() {
      if (this.dates.length === 2) {
        return `${this.startDate.toLocaleDateString()} - ${this.endDate.toLocaleDateString()}`;
      } else {
        return 'Select Date Range';
      }
    },
  },
  methods: {
    ...mapActions('metrics', ['fetchMetrics', 'fetchFilterValues']),
    async onMenuOk() {
      this.$refs.menu.save(this.dates);
      await this.onFilterChange();
    },
    async onFilterChange() {
      if(this.selectedRoles.length === 0 ||
          this.selectedRoles.length === 0 ||
          this.endDate === null ||
          this.startDate === null)
      {
        return;
      }

      const start = this.startDate.getTime();
      const end = this.endDate.getTime();

      await this.fetchMetrics({ start, end, selectedCommunes: this.selectedCommunes, selectedRoles: this.selectedRoles });
    }
  },
  async mounted() {
    if (!this.enableAnalytics) {
      await this.$router.replace({ name: 'home' });
    } else {
      await this.fetchFilterValues();
      this.selectedCommunes = this.filterValues.communes;
      this.selectedRoles = this.filterValues.roles;
    }
  }
}
</script>

<template>
  <div class="pa-5 new-wrapper">
  <v-row>
    <v-col cols="12">
      <breadcrumbs />
      <div class="custom-header-text">Analytics</div>
    </v-col>
    <v-col cols="12" md="4">
      <v-select prepend-inner-icon="mdi-city" filled label="Kommunen" @change="onFilterChange"
                background-color="#F1CBDB" v-model="selectedCommunes" :items="filterValues.communes" multiple>
        <template v-slot:selection="{ item, index }">
            <span v-if="index === 0" class="mr-1">{{ item }}</span>
          <span
              v-if="index === 1"
              class="grey--text text-caption"
          >
           (+{{ selectedCommunes.length - 1 }} weitere)
        </span>
        </template>
      </v-select>
    </v-col>
    <v-col cols="12" md="4">
      <v-select prepend-inner-icon="mdi-city" filled label="Rollen" @change="onFilterChange"
                background-color="#F1CBDB" v-model="selectedRoles" :items="filterValues.roles" multiple>
        <template v-slot:selection="{ item, index }">
          <span v-if="index === 0" class="mr-1">{{ item }}</span>
          <span
              v-if="index === 1"
              class="grey--text text-caption"
          >
           (+{{ selectedRoles.length - 1 }} weitere)
        </span>
        </template>
      </v-select>
    </v-col>
    <v-col cols="12" md="4">
      <v-menu
          ref="menu"
          :close-on-content-click="false"
          :return-value.sync="dates"
          transition="scale-transition"
          offset-y min-width="auto">
        <template v-slot:activator="{ on, attrs }">
          <v-text-field label="Timeframe" prepend-inner-icon="mdi-calendar" readonly
                        v-model="dateRangeText"
                        filled
                        background-color="#F1CBDB"
                        v-bind="attrs" v-on="on"></v-text-field>
        </template>
        <v-date-picker
            v-model="dates"
            no-title
            range
            color="primary"
            scrollable>
          <v-spacer></v-spacer>
          <v-btn
              text
              color="primary"
              @click="menu = false"
          >
            Cancel
          </v-btn>
          <v-btn
              text
              color="primary"
              @click="onMenuOk"
          >
            OK
          </v-btn>
        </v-date-picker>
      </v-menu>
    </v-col>
  </v-row>
    <v-row v-if="metrics">
      <v-col cols="12">
        <div class="font-weight-bold">Kommunalportal ({{ metrics.totalUsers }} Benutzer)</div>
      </v-col>
      <v-col cols="12" md="4">
        <p>Neuanmeldungen pro Kommune: </p>
        <expandable-table :items="metrics.communeCounts" name-header="Kommune" value-header="Anmeldungen" />

        <p class="mt-5">Neuanmeldungen pro Rolle: </p>
        <expandable-table :items="metrics.roleCounts" name-header="Rolle" value-header="Anmeldungen" />
      </v-col>
      <v-col cols="12" md="4">
        <p>NEW-Magazin:</p>
        <expandable-table :items="metrics.news" name-header="Artikel" value-header="Aufrufe" />

        <p class="mt-5">NEW-Pressemeldungen</p>
        <expandable-table :items="metrics.press" name-header="Artikel" value-header="Aufrufe" />
      </v-col>
      <v-col cols="12" md="4">
        <p>Seitenaufrufe: </p>
        <expandable-table :items="metrics.kommunalportalStats" name-header="Seite" value-header="Aufrufe" />
      </v-col>
      <v-col cols="12">
        <div class="font-weight-bold">Bildungsportal</div>
      </v-col>
        <v-col cols="12" md="4">
          <p>Neuanmeldungen pro Kommune: </p>
          <expandable-table :items="metrics.bildungsportalCommuneCounts" name-header="Kommune" value-header="Anmeldungen" />

          <p class="mt-5">Neuanmeldungen pro Rolle: </p>
          <expandable-table :items="metrics.bildungsportalRoles" name-header="Rolle" value-header="Anmeldungen" />
        </v-col>
      <v-col cols="12" md="4">
        <p>Gruppiert nach Materialtyp:</p>
        <expandable-table :items="metrics.bildungsportalStats.detailed.type" name-key="materialTyp" name-header="Materialtyp" value-header="Aufrufe" />

        <p class="mt-5">Gruppiert nach Thema:</p>
        <expandable-table :items="metrics.bildungsportalStats.detailed.topic" name-header="Materialtyp" value-header="Aufrufe" />

        <p class="mt-5">Downloads:</p>
        <expandable-table :items="metrics.bildungsportalStats.files" name-header="Materialtyp" value-header="Anzahl" />
      </v-col>
      <v-col cols="12" md="4">
        <p>Seitenaufrufe: </p>
        <expandable-table :items="metrics.bildungsportalStats.general" name-header="Seite" value-header="Aufrufe" />
      </v-col>
    </v-row>
  </div>
</template>

<style scoped>

</style>
